export const useStoreHeader = defineStore('StoreHeader', {
    state: () => ({
        menuOpen: false,
        menuItems: [{route: '/classes', text: 'Classes'}],
    }),
    actions: {
        toggleMenu() {
            this.menuOpen = !this.menuOpen;
        },
        closeMenu() {
            this.menuOpen = false;
        },
    },
});
